import React from "react";
import Title from "./Title";
import { Link } from "gatsby";
import Testimonial from "./Testimonial";

export const Testimonials = ({ testimonials, title, showLink }) => {
  return <section className="section">
    <Title tittle={title} />
    <div className="section-center blogs-center">
      {testimonials.map((testimonial) => {
        return <Testimonial name={testimonial.Name}
                            image={testimonial.image}
                            company={testimonial.company}
                            testimony={testimonial.testimony}
        />;
      })}
    </div>
    {showLink && (
      <Link to="/blog" className="btn center-btn">
        Testimonials
      </Link>
    )}
  </section>;
};
export default Testimonials;
